











































































































































import Vue from 'vue'
import Component from 'vue-class-component'
// cookies
import Cookies from 'js-cookie'
// store
import moduleStore from './store/VipWechatPay'
// components
import PayCard from '@/components/pay/pay.vue'
import { Toast, Dialog } from 'vant'
import { customCollectEvent } from '@/utils/collect';

@Component({
  components: {
    PayCard
  }
})
@moduleStore.initVuex({
  mutationNames: moduleStore.mutationNames,
  actionNames: moduleStore.actionNames
})
export default class vipWechatPay extends Vue {

  // assets
  support = require('/public/images/member/icon_support.svg')
  not_support = require('/public/images/member/icon_not_support.svg')

  created() {

  }

  mounted() {
    this.getUrlParams()
    this.init()
  }

  /****************************** 判断系统 ******************************/

  // 是/否是 iOS 系统
  isIOSplatform = false

  init() {
    // 判断系统
    const ua = navigator.userAgent
    const iOS = /iPad|iPhone|iPod/.test(ua)
    this.isIOSplatform = iOS
    
    if (this.getAuth()) {
      // 请求接口
      this.getChannelCodeName()
        .then(() => {
          this.getChannelPackageList()
          this.getYcdRightsList()
          this.getYcdPackageContent()
        })
    }
  }

  getUrlParams() {
    // 清除原本的 cookies
    if (Cookies.get('USER_CODE')) Cookies.remove('USER_CODE')
    if (Cookies.get('CHANNEL_CODE')) Cookies.remove('CHANNEL_CODE')
    const href = window.location.href
    if (href.indexOf('/?code') !== -1) {
      const urlArr = href.split('/?')
      const rightUrlArr = urlArr[1].split('#/')
      const queryObj = {}
      // 获取code和state参数
      rightUrlArr[0]
        .split('&')
        .map((item) => {
          const splitStr = item.split('=')
          return {
            key: splitStr[0],
            value: splitStr[1],
          }
        })
        .forEach((item) => {
          queryObj[item.key] = item.value
        })
      if (queryObj['code']) {
        sessionStorage.setItem('USER_CODE', queryObj['code'])
        Cookies.set('USER_CODE', queryObj['code'] as string, { expires: 270 / 24 / 60 / 60 })

      }
      if (queryObj['state']) {
        if (queryObj['state'].includes('|||')) {
          Cookies.set('CHANNEL_CODE', queryObj['state'][0] as string, { expires: 1 })
          Cookies.set('CHANNEL_TARGET', queryObj['state'][1] as string, { expires: 1 })
        } else {
          Cookies.set('CHANNEL_CODE', queryObj['state'] as string, { expires: 1 })
        }
      }
    }
    if (href.indexOf('channelCode=') !== -1) {
      let paramsArr = href.split('channelCode=')
      let supStr = paramsArr[1].split('&')[0]
      if (supStr.indexOf('ww_token') !== -1) {
        Cookies.set('CHANNEL_CODE', supStr.split("ww_token")[0], { expires: 1 })
      } else {
        Cookies.set('CHANNEL_CODE', supStr, { expires: 1 })
      }
      this.channelCode = supStr;
    }
  }
  
  getUrlCode() {
    // 在 url 后面拼上 jscode ，用于本地和测试环境测试
    const urlJSCode = this.$route.query.custom_jscode
    if (urlJSCode) return urlJSCode
  
    let href = window.location.href
    if (Cookies.get('USER_CODE')) {
      return Cookies.get('USER_CODE')
    }
    if (href.indexOf('code=') !== -1) {
      const urlArr = href.split('?')
      const rightUrlArr = urlArr[1].split('#/')
      const queryObj = {}
      // 获取code和state参数
      rightUrlArr[0]
        .split('&')
        .map((item) => {
          const splitStr = item.split('=')
          return {
            key: splitStr[0],
            value: splitStr[1],
          }
        })
        .forEach((item) => {
          queryObj[item.key] = item.value
        })
      if (queryObj['code']) {
        return queryObj['code']
      }
    }
    if (sessionStorage.getItem("USER_CODE")) {
      return sessionStorage.getItem("USER_CODE")
    }
    return null
  }

  getAuth() {
    let jsCode = this.getUrlCode()
    // let jsCode = '0411Yo100etdlS1hsO300L5QiB21Yo1g'
    if (!jsCode) {
      // 获取 channelCode
      let  channelCode = Cookies.get('CHANNEL_CODE') || '';
      if(channelCode.includes('|||')){
        channelCode = '';
      }
      let myURL = location.href
    //   if(location.href.indexOf("m.moyin.com")){
    //     //公众号支付只能配置两个域名，且6月修改次数已用完，临时代码替换
    //     myURL=location.href.replace('m.moyin.com','tc-nj-m.moyin.com')
    //   }
      // 调用授权登录接口
      window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxea4ae255733cb575&redirect_uri=${encodeURIComponent(myURL)
        }&response_type=code&scope=snsapi_base&state=${encodeURIComponent(channelCode)
        }#wechat_redirect`

      return false
    } else {
      this.orderParams.jsCode = jsCode
      return true
    }
  }

  /****************************** 渠道码 ******************************/

  // 渠道码
  channelCode = ''
  // 渠道名
  channelName = ''

  /** 获取渠道名称 */
  getChannelCodeName() {
    return new Promise((resolve, reject) => {
      const channelCode = Cookies.get('CHANNEL_CODE') || ''
      this.$http('getChannelName', {
        channelCode
      })
        .then(res => {
          const { code, data } = res
          if (code === 200) {
            //两种 传了channelCode就查数据库，查到就返回对应的渠道名称，没查到就固定返回“官方渠道” 没传就返回channelCode为office_mobvoi对应的渠道名称
            this.channelName = data
            resolve(data)
          } else {
            reject()
          }
        })
        .catch(() => {
          reject()
        })
    })
  }


  /****************************** 渠道套餐 ******************************/

  // 渠道套餐列表
  channelPackageList = []

  // 获取渠道套餐列表
  getChannelPackageList() {
    // 渠道码
    const channelCode = Cookies.get('CHANNEL_CODE') || ''
    // 获取套擦
    this.$http('getVipPriceList', {
      channelCode,
      ww_token: '',
      sourceEnum: 'MINI_PROGRAM'
    })
      .then(res => {
        const { code , data, msg } = res
        if (code === 200) {
          const ycdPackageList = data.bhVipPack || []
          if (!ycdPackageList.length) {
            Toast({
              message: '官方渠道暂无元创岛套餐',
              icon: "none",
              duration: 3000,
              position: 'top'
            })
          }
          this.channelPackageList = ycdPackageList.map((item, index) => {
            // 渠道价格
            const channelPrice = (Number(item.channelPrice) / 100).toFixed(2).replace(/\.00/, '')
            // 原价价格
            const price = (Number(item.price) / 100).toFixed(2).replace(/\.00/, '')
            // 日均价格
            const dailyPrice = (Number(item.channelPrice) / (100 * item.vipDays)).toFixed(2)

            return {
              ...item,
              channelPrice,
              dailyPrice,
              price
            }
          })
        } else {
          console.error(msg)
        }
      })
      .catch(() => {

      })
  }

  // 当前选择的套餐 index
  activeChannelPackageIndex = 0

  // 当前选择的渠道套餐
  get activeChannelPackageItem() {
    return this.channelPackageList[this.activeChannelPackageIndex] || {}
  }

  handleChoosePackage(index) {
    if (this.activeChannelPackageIndex === index) return
    this.activeChannelPackageIndex = index
  }

  /****************************** 会员权益列表 ******************************/

  // 单位 map
  unitMap = {
    'day': '天',
    'month': '个月',
    'year': '年'
  }

  // 元创岛套餐详情列表（需要从这个列表中获取元创岛套餐）
  ycdPackageContent = []

  get activeYcdPackageContent() {
    return this.ycdPackageContent.find(item => {
      return item.packageId === this.activeChannelPackageItem.id
    }) || {}
  }

  getYcdPackageContent() {
    const params = {
      type: 1,
      isShow: false
    }
    this.$http('getYcdPackageListApi', params)
      .then(res => {
        const { code, data } = res
        if (code === 200) {
          this.ycdPackageContent = data
        }
      })
  }

  // 元创岛会员权益
  ycdRightsContent = []

  // 获取元创岛会员权益
  getYcdRightsList() {
    this.$http('getYcdVipRightsListApi')
      .then(res => {
        const { code, data } = res
        if (code === 200) {
          this.ycdRightsContent = data
        }
      })
  }

  /****************************** 切换支付方式 ******************************/

  handlePayTypeChange(type) {
    this.orderParams.payType = type
  }

  handlePayPhoneChange(phone) {
    this.orderParams.phone = phone
  }

  /****************************** 创建订单 ******************************/

  orderParams = {
    // 支付方式
    payType: 0,
    // 支付绑定的手机号
    phone: '',
    // jsCode
    jsCode: ''
  }

  showBuyConfirmPopup() {
    const { phone } = this.orderParams
    const jsCode = this.getUrlCode()
    if (!(this.$refs.payCard as any).phoneCheck()) {
      return
    } else if (jsCode === "" || !jsCode) {
      if (!this.getAuth()) {
        return
      }
    }
    Dialog.confirm({
      title: `请确认手机号:${ phone }`,
      message: '',
      confirmButtonText: '确认购买',
      cancelButtonText: '修改手机号',
      className: 'rel-dialog'
    })
      .then(() => {
        this.createOrder()
      })
      .catch(() => {
        // on cancel
        let focusNode: any = this.$refs.payCard
        focusNode.focus()
      })
  }

  createOrder() {
    // 手机号 && jsCode
    const { payType, phone, jsCode } = this.orderParams
    // 渠道码
    const channelCode = Cookies.get('CHANNEL_CODE') || ''
    // 创建订单参数（魔音是 0 ，元创岛是 1）
    const sourceType = 1

    const params = {
      jsCode,
      channelCode,
      payType,
      phone,
      sourceType,
      packageId: this.activeChannelPackageItem.id,
      speakerStoreIDArray: '',
      speakerIdArray: ''
    }

    this.$http('paySuperVip', {
      ...params
    })
      .then(res => {
        const { code, data, message } = res
        if (code === 200) {
          const payComponent = this.$refs.payCard as any
          // 支付宝支付
          if(payType === 1) {
            payComponent.aliPay({...data, from: 'ycd-channel', isVoice: ''}, '/ycdPaySuccess')
            return
          }
          const { appId, timeStamp, nonceStr, signType, paySign, package: prepayId, orderId } = data
          // 微信支付参数
          const bridgeParams = {
            appId,
            timeStamp,
            nonceStr,
            signType,
            paySign,
            package: prepayId
          }
          // 调用微信的发起支付接口
          payComponent.wxPay(bridgeParams)
            .then(() => {
              //会员支付成功埋点
              try{
                customCollectEvent('vip_pay_success', {
                  amount: (this.activeChannelPackageItem.price || 0) / 100,
                  button: `元创岛 ${ this.activeChannelPackageItem.title || '' }`,
                  channel_code: channelCode || '',
                  user_id: ''
                });  
              }catch(e){
                console.log('购买会员成功埋点失败',e)
              }
              this.$router.push({
                path: '/ycdPaySuccess',
                query: {
                  phone: this.orderParams.phone,
                  title: `元创岛 ${ this.activeChannelPackageItem.title || '' }`,
                  rightsNum: `${ this.ycdRightsContent.length }`
                }
              })
            })
        } else {
          Toast({
            message: message,
            icon: "none",
            duration: 3000,
            position: 'top'
          })
        }
      })
  }

  toProtocol(name: string) {
    switch(name) {
      case 'protocol':
        window.open('https://h5.yuan365.com/#/protocol')
        break;
      case 'privacy':
        window.open('https://h5.yuan365.com/#/privacy')
        break;
    }
  }

}

